export type VerifiableEntity = {
  verified?: boolean;
  employerVerified?: boolean;
  status?: string;
  employer?: { verified?: boolean; status?: string };
  company?: { verified?: boolean; status?: string };
};

const isVerifiedStatus = (status?: string) => typeof status === 'string' && status.toLowerCase() === 'verified';

export function isEmployerVerified(entity: unknown): boolean {
  const candidate = entity as VerifiableEntity | undefined;
  if (!candidate) return false;
  if (typeof candidate.verified === 'boolean') return candidate.verified;
  if (typeof candidate.employerVerified === 'boolean') return candidate.employerVerified;
  if (isVerifiedStatus(candidate.status)) return true;

  const employer = candidate.employer;
  if (employer) {
    if (typeof employer.verified === 'boolean') return employer.verified;
    if (isVerifiedStatus(employer.status)) return true;
  }

  const company = candidate.company;
  if (company) {
    if (typeof company.verified === 'boolean') return company.verified;
    if (isVerifiedStatus(company.status)) return true;
  }

  return false;
}
